module.exports = __webpack_public_path__ + "img/notice.87500f45.png";